import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useApi from "../../../../core/customhook/useApi";
import Loader from "../../../../core/common/selfLoder";
import AssetSection from "./AssetSection";


interface AssetType {
  assets_id: string;
  assets_type: string;
}

interface Asset {
  asset_name: string;
  asset_attachement: string;
  assets_type: string;
}

interface AssetTypeResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: AssetType[];
}

interface AssetResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Asset[];
}

const DigitalAssets = () => {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [assetLoading, setAssetLoading] = useState(false);
  const { base } = useParams(); // ✅ e.g. 'logos', 'screensaver'

  // console.log(base, "this is the base clickable Route");


  const { data: assetTypeResponse, loading: typeLoading } =
    useApi<AssetTypeResponse>("/api/master/get-assets-type", {
      method: "GET",
      autoCall: true,
    });

  const { callApi: getAssetsApi } = useApi<AssetResponse>("/api/get-assets", {
    method: "POST",
    autoCall: false,
  });

  useEffect(() => {
    const fetchAssets = async () => {
      setAssetLoading(true);
      const allAssets: Asset[] = [];

      try {
        for (const type of assetTypeResponse?.data || []) {
          const res = await getAssetsApi({
            category: type.assets_id,
          });
          if (res?.success) {
            allAssets.push(...res.data);
          }
        }
        setAssets(allAssets);
      } catch (error) {
        console.error("Error fetching assets:", error);
      } finally {
        setAssetLoading(false);
      }
    };

    if (assetTypeResponse?.data) {
      fetchAssets();
    }
  }, [assetTypeResponse]);

  return (
    <>
      <Loader loading={typeLoading || assetLoading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>
                Digital Assets
                {base && assetTypeResponse?.data?.length
                  ? ` (${assetTypeResponse.data.find(
                    (t) =>
                      t.assets_type.toLowerCase().replace(/\s+/g, "-") === base
                  )?.assets_type || "Unknown"
                  })`
                  : ""}

              </h4>
            </div>
          </div>


          <div className="row">
            {(assetTypeResponse?.data || [])
              .filter((type) =>
                base
                  ? type.assets_type.toLowerCase().replace(/\s+/g, "-") === base
                  : true
              )
              .map((type, i) => {
                const typeAssets = assets.filter(
                  (a) => a.assets_type === type.assets_id
                );

                return (
                  <div className="col-sm-12" key={i}>
                    <AssetSection title={type.assets_type} assets={typeAssets} />
                  </div>
                );
              })}
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default DigitalAssets;
